const OUTCOME_LABELS = {
  appointment_booked: "Booked",
  appointment_cancelled: "Cancelled",
  appointment_rescheduled: "Rescheduled",
  human_transfer: "Transferred to staff",
  info_request: "Question answered",
  question_answered: "Question answered",
  failed: "Failed",
};

export function outcomeLabel(outcome) {
  return OUTCOME_LABELS[outcome] || (outcome ? outcome.replaceAll("_", " ") : "—");
}
